/*
* Usage:
* <Icon className="map-loader" type="loading" spin={true}/>
*/
import React from 'react';
import classnames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const classes = classnames('icon', `icon-${this.props.type}`, this.props.className);
    const href = `spritemap.svg#icon-${this.props.type}`;

    return (
      <svg className={classes}>
        <use xlinkHref={href}></use>
      </svg>
    );
  }
}

export default Icon;
